const billingTypeHelpers = {
  // Pallet-based billing types
  "By the Pallet": "Example: Use when you received pre-palletized pallets. You'll then specify the type of pallet (standard, oversized, etc.)",
  "By the Pallet (Warehouse-Built)": "Example: Use when loose items need to be palletized by the warehouse",

  // Unit/Item-based billing types
  "By the Unit/Item": "Example: Use when you receive loose items such as _______",
  "By the Vault": "Example: Use for items that'll be stored in a wooden vault",

  // Square footage billing types
  "Square Foot by Item Dimensions": "Example: Used typically for items that are too large to fit in a rack bay.",
  "Square Foot by Location Dimensions": "Example: Use when storing items in a rack bay, floor spot, or trailer.",

  // Cubic footage billing types
  "Cubic Foot by Item Dimensions": "Example: Use for items charged by volume (length × width × height)",
  "Cubic Foot by Location Dimensions": "Example: Use when charging by the cubic space of the storage location",

  // Storage location billing types
  "Storage Locations Occupied": "Example: Use for charging by the storage location (rack bay, vault, shelf, etc.)",

  // Weight-based billing types
  "Hundredweight": "Example: Use for items that are charged by weight.",

  // Other billing types
  "Flat Rate/As Quoted": "Example: Use for pre-negotiated fixed pricing regardless of quantity",
  "Time and Materials (T&M)": "Example: Use for variable work requiring hourly labor and materials tracking",
};

export const getBillingTypeHelperText = (billingType) => {
  return billingTypeHelpers[billingType] || `Specify when to use "${billingType}"`;
};

export default getBillingTypeHelperText;
